export default {
  HANDLE_SUCCESS_GET_PAYMENT_METHODS: 'handleSuccessGetPaymentMethods',
  TOGGLE_PAYMENT_METHOD_MODAL: 'togglePaymentMethodModal',
  HANDLE_SUCCESS_GET_PAYMENT_METHOD_TYPES: 'handleSuccessGetPaymentMethodTypes',
  TOGGLE_ADD_PAYMENT_METHOD_MODAL: 'toggleAddPaymentMethodModal',
  HANDLE_SELECTED_PAYMENT_METHOD_TYPE: 'handleSelectedPaymentMethodType',
  TOGGLE_PAYMENT_METHOD_DETAILS_MODAL: 'togglePaymentMethodDetailsModal',
};



// WEBPACK FOOTER //
// ./src/app/main/payment-methods/constants/action-types.js